/* 荀彧（字文若） */
import { gd } from '../../core/kit.ts';
import { defineHero, U, P } from '../define.ts';

export default defineHero({
  id: 'xunyu', name: '荀彧', sub: '字文若', faction: 'wei', role: '法師/輔助', weapon: 'staff',
  look: { head: 'guan', robe: true, beard: 'goatee', fx: '#ffe28a', c: { cloth: '#4a6a8a', sleeve: '#4a6a8a', pole: '#6b4a2a' } },
  skills: [
    ['致命結界', 'trap', '立起結界 15 秒，範圍內敵人每秒損失 {15/25/35/45} 生命。', { x: { k: 'zone', r: 220, dur: 15, dps: [15, 25, 35, 45], pal: 'poison' }, aim: P(400, 220), el: 'shadow' }],
    ['治療之風', 'heal', '治療一名友軍 {75/125/175/225} 生命，並在附近友軍間彈跳 {3/4/5/6} 次。', { x: { k: 'healwave', heal: [75, 125, 175, 225], n: [3, 4, 5, 6] }, aim: U(480) }],
    ['靜滯結界', 'trap', '埋下隱形結界 80 秒，敵人靠近時觸發，範圍內昏迷 {3/4/5/6} 秒。', { x: { k: 'zone', r: 180, dur: 80, mine: 1, trig: 90, cc: { stun: [3, 4, 5, 6] } }, aim: P(400, 180) }],
    ['蛇型結界', 'summon', '召喚 8 個固定不動、魔法免疫的蛇形結界 40 秒，每個生命 {150/225/300}、攻擊 {30/45/60}。', { x: { k: 'summon', n: 8, hp: [150, 225, 300], atk: [30, 45, 60], dur: 40, still: true, range: 400, immune: true, spread: 80, skin: 'snake', name: '蛇形結界' }, aim: P(400, 100) }],
  ],
  // 專屬技能（技能資料裡的 x.k）
  kinds: {
    healwave(u, a, X) {
      let cur = this.xAlly(u, a.pt, this.skillRange(a.sk, a.lvl), true), v = X.heal;
      const seen: Record<number, number> = {};
      for (let j = 0; j <= X.n && cur; j++) {
        const t = cur, amt = v;
        seen[t.id] = 1;
        this.later(0.12 * j, () => { this.heal(t, amt); this.fx({ k: 'heal', x: t.x, y: t.y, col: u.spec.fx }); });
        v *= 0.75;
        cur = this.units.filter((o) => o.alive && o.team === u.team && !o.structure && o.kind !== 'ward' && !seen[o.id] && o.hp < o.maxHp && gd(t.x, t.y, o.x, o.y) < 400).sort((p, q) => +(q.kind === 'hero') - +(p.kind === 'hero') || p.hp / p.maxHp - q.hp / q.maxHp)[0];
      }
    },
  },
});
